export default __webpack_public_path__ + "JFt_family.html";